export default __webpack_public_path__ + "static/media/bag-white.69d04f9c.svg";